import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiClient, ApiType } from '@shared/apiClient';
import { actions } from '@redux/modules/membershipBenefitSearch';

export const useFetchMembershipBenefits = () => {
  const dispatch = useDispatch();

  const runFetch = useCallback(async (params: string) => {
    try {
      const response = await apiClient.get(ApiType.apimNafNoApi, {
        url: `benefits?${params}`,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  }, []);

  const getTags = useCallback(
    async (queryString: string) => runFetch(`${queryString}&HideItems=true&ApplyOrder=true`),
    [runFetch],
  );

  const baseQuery = 'Take=100&page=0&&ShowTagInfo=false&ApplyOrder=true';

  const getCampaignBenefits = useCallback(
    async (queryString: string) => runFetch(`${queryString}&${baseQuery}&HasActiveCampaign=true`),
    [runFetch],
  );

  const getFixedBenefits = useCallback(
    async (queryString: string) => runFetch(`${queryString}&${baseQuery}`),
    [runFetch],
  );

  const updateAllBenefits = useCallback(
    async (queryString: string, selectedTags: string[] = []) => {
      const [tags, dataActive, dataInactive] = await Promise.all([
        getTags(queryString),
        getCampaignBenefits(queryString),
        getFixedBenefits(queryString),
      ]);

      const combinedItems = [...(dataActive?.items ?? []), ...(dataInactive?.items ?? [])];
      const total = (dataActive?.total ?? 0) + (dataInactive?.total ?? 0);
      const countTotalItemsInTextSearch = tags?.countTotalItemsInTextSearch ?? 0;
      const availableTags = tags?.availableTags ?? [];

      dispatch(
        actions.update({
          skip: 0,
          total,
          countTotalItemsInTextSearch,
          availableTags,
          selectedTags,
          items: combinedItems,
        }),
      );
    },
    [dispatch, getCampaignBenefits, getFixedBenefits, getTags],
  );

  return { updateAllBenefits };
};
